import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-312dd874"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "content" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "el-upload__text" }, [
  /*#__PURE__*/_createTextVNode(" Drop file here or "),
  /*#__PURE__*/_createElementVNode("em", null, "click to upload")
], -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "el-upload__tip" }, " 请上传正确的BookMarks文件！！！，大小不超过2MB ", -1))

import { reactive, ref } from 'vue'
import {GetBookmarks} from "../http/index"
import { ElMessage } from "element-plus";
import { UploadFilled } from '@element-plus/icons-vue'
import type { UploadProps } from 'element-plus'
import config from '@/http/index';


export default /*#__PURE__*/_defineComponent({
  __name: 'Initializebbar',
  setup(__props) {

const handleAvatarSuccess: UploadProps['onSuccess'] = (
  response,
  uploadFile
) => {
  ElMessage.success(`${response.msg}`)
}

const handleAvatarError:UploadProps['onError'] = (
  response,
  UploadFilled
) =>{
   ElMessage.error(`${response.msg}`)
}

const beforeAvatarUpload: UploadProps['beforeUpload'] = (rawFile) => {
  if (rawFile.size / 1024 / 1024 > 2) {
    ElMessage.error('文件不能超过 2MB!')
    return false
  }
  return true
}


return (_ctx: any,_cache: any) => {
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_upload = _resolveComponent("el-upload")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_upload, {
      class: "upload-demo",
      drag: "",
      action: _unref(config).action,
      multiple: "",
      method: "post",
      name: "file",
      "on-success": handleAvatarSuccess,
      "on-error": handleAvatarError,
      "before-upload": beforeAvatarUpload,
      style: {"width":"500px"}
    }, {
      tip: _withCtx(() => [
        _hoisted_3
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_icon, { class: "el-icon--upload" }, {
          default: _withCtx(() => [
            _createVNode(_unref(UploadFilled))
          ]),
          _: 1
        }),
        _hoisted_2
      ]),
      _: 1
    }, 8, ["action"])
  ]))
}
}

})